import React, { useState, useRef, useEffect } from 'react'
import Breadcrumb from '../../../../Components/Breadcrumb/Breadcrumb'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function BestAmbassadorSelection() {
    // bootstrap states
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    // bootstrap states

    const [isChecked, setIschecked] = useState(false)
    const juryDecision = (e) => {
        const juryDecisionChecked = e.target.checked
        setIschecked(juryDecisionChecked);
    }

    const tableRef = useRef();

    const downloadPDF = () => {
        const input = tableRef.current;
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF('p', 'mm', 'a4');
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
                pdf.save('from-table.pdf');
            });
    };

    const [pdfFile, setPdfFile] = useState()
    const uploadForm = (e) => {
        // console.log("Selected File", e.target.files[0]);
        setPdfFile(e.target.files[0])
    }

    const [totalMarks, setTotalMarks] = useState()
    const [awardedMarks, setAwardedMarks] = useState()
    const [trigger, setTrigger] = useState(false)
    useEffect(() => {
        const gettingfromApi = [10, 20, 10]
        const totalValue = gettingfromApi[0] + gettingfromApi[1] + gettingfromApi[2] + (awardedMarks ?? 0)
        setTotalMarks(totalValue)
        // console.log("totalValue", awardedMarks);
        setTrigger(false)
    }, [trigger]);

    const marksChange = (e) => {
        const marksValue = e.target.value
        const numberMarksValue = Number(marksValue)
        setAwardedMarks(numberMarksValue)
        setTrigger(true)
    }
    return (
        <>
            <Breadcrumb data="Lead Ambassador Selection" />
            <div className='content-body'>
                <div className='table-data'>
                    <div className='table-responsive'>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th colSpan={3}>Evaluation</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={3}>Total no of Participant</td>
                                    <td id='point1'>10</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>Total no of event conducted</td>
                                    <td id='point2'>20</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>Jury Decision (If Required)</td>
                                    <td id='point3'>10</td>
                                </tr>
                                <tr>
                                    <td colSpan={3}>
                                        <div className='d-flex justify-content-start align-items-center'>
                                            <input checked={isChecked} onChange={juryDecision} style={{ width: "20px", height: "20px", marginRight: "10px" }} type="checkbox" id='juryDecision' />
                                            <label htmlFor='juryDecision'>Jury Decision Require</label>
                                        </div>
                                    </td>
                                    <td><button className='download-btn' type='button' variant="primary" onClick={handleShow}>Download</button></td>
                                </tr>
                                {isChecked &&
                                    <   >
                                        <tr>
                                            <td colSpan={3}>Upload Jury form</td>
                                            <td>
                                                <input className='d-none' type="file" accept='application/pdf' id='uploadQuestionForm' onChange={uploadForm} />
                                                <label htmlFor='uploadQuestionForm' className='download-btn'>Upload</label>
                                                {pdfFile && <span className='text-success ms-3'>{pdfFile.name}</span>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>Marks awarded by Jury</td>
                                            <td><input type="number" onChange={marksChange} name='awardedJury'/></td>
                                        </tr>
                                    </>}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={3}>Total Marks</th>
                                    <th>{totalMarks}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Questions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='table-data'>
                        <div className='table-responsive questions-form'>
                            <table className='table table-bordered mb-0' ref={tableRef}>
                                <tbody>
                                    <tr>
                                        <th>S.No</th>
                                        <th colSpan={2}>Questions</th>
                                        <th>Marks</th>
                                    </tr>
                                    <tr>
                                        <td>Q1.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q2.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q3.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q4.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q5.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q6.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q7.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q8.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q9.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td>Q10.</td>
                                        <td colSpan={2}><input type="text" /></td>
                                        <td><input type="number" /></td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "25%" }}>
                                            Name & Signature of Jury
                                            <input className='mb-2 mt-3' type="text" />
                                            <input type="text" />
                                        </td>
                                        <td style={{ width: "25%" }}>
                                            Name & Signature of Jury
                                            <input className='mb-2 mt-3' type="text" />
                                            <input type="text" />
                                        </td>
                                        <td style={{ width: "25%" }}>
                                            Name & Signature of Jury
                                            <input className='mb-2 mt-3' type="text" />
                                            <input type="text" />
                                        </td>
                                        <td style={{ width: "25%" }}>
                                            Name & Signature of Jury
                                            <input className='mb-2 mt-3' type="text" />
                                            <input type="text" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => { handleClose(); downloadPDF(); }}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default BestAmbassadorSelection
